import { ProColumns } from "@ant-design/pro-components";
import { useTable, type ApiFunction, type Search } from "./useTable";

type UsePageTableFn<T> = {
  fetchFn: ApiFunction;
  columns: ProColumns<T>[];
};

export function usePageTable<T, P extends Search>({
  fetchFn,
  columns,
}: UsePageTableFn<T>) {
  return useTable({
    fetchFn,
    columns,
    formatter: (rawParams: P) => {
      const { current: pageNum, pageSize, ...restParams } = rawParams;
      return {
        pageNum,
        pageSize,
        ...restParams,
      };
    },
  });
}
